import { isMemberUpdateAuthorizationsResponse, isMemberUpdateCapabilitiesResponse, } from '@urbanik/api-contracts';
export class MemberUpdateAuthorizationApiError extends Error {
}
async function call(url, guard, init) {
    let response;
    try {
        response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
            },
        });
    }
    catch {
        throw new MemberUpdateAuthorizationApiError('No pudimos conectar con el servidor.');
    }
    const payload = await response.json().catch(() => null);
    if (!response.ok)
        throw new MemberUpdateAuthorizationApiError(payload && typeof payload.message === 'string'
            ? payload.message
            : 'No pudimos gestionar la autorización.');
    if (!guard(payload))
        throw new MemberUpdateAuthorizationApiError('El servidor devolvió un contrato inválido.');
    return payload;
}
const endpoint = (base, memberId) => `${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/update-authorizations`;
export const getMemberUpdateAuthorizations = (base, memberId) => call(endpoint(base, memberId), isMemberUpdateAuthorizationsResponse);
export const getMemberUpdateCapabilities = (base) => call(`${base.replace(/\/$/, '')}/identity/member-profile/update-capabilities`, isMemberUpdateCapabilitiesResponse);
export const createMemberUpdateAuthorization = (base, memberId, input) => call(endpoint(base, memberId), isMemberUpdateAuthorizationsResponse, { method: 'POST', body: JSON.stringify(input) });
export const revokeMemberUpdateAuthorization = (base, memberId, authorizationId, input) => call(`${endpoint(base, memberId)}/${encodeURIComponent(authorizationId)}/revoke`, isMemberUpdateAuthorizationsResponse, { method: 'POST', body: JSON.stringify(input) });
